exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-name[data-v-566bbea2]{display:flex;flex:1}.wrap-name[data-v-566bbea2],.wrap-name .intv-name[data-v-566bbea2]{white-space:nowrap;overflow:hidden}.wrap-name .intv-name[data-v-566bbea2]{text-overflow:ellipsis}.disabledBg[data-v-566bbea2]{background-color:#fff}", ""]);

// exports
